import { CodeSnippet } from '@/components/page/blog/CodeSnippet';
import { PostBody } from '@/components/page/blog/PostBody';
import { PostBodyImage } from '@/components/page/blog/PostBodyImage';
import { PostBodyVideo } from '@/components/page/blog/PostPageVideo';
import { StandoutComponent } from '@/components/page/blog/StandoutComponent';

export const formatDate = (date: string) => {
  const formattedDate = new Date(`${date}T00:00`).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  return formattedDate;
};

export const dateTimeFormat = (date: string) => {
  const formattedDate = new Date(date).toLocaleDateString('en-CA');
  return formattedDate;
};

export const getComponent = (postBody, blogPost) => {
  const UlList = [];
  const ulFirstId = [];
  const OlList = [];
  const olFirstId = [];
  const splitUlList = [];
  const splitOlList = [];

  // eslint-disable-next-line array-callback-return
  postBody.map((item) => {
    if (item.listItem === 'bullet') {
      UlList.push(item);
      const index = postBody.indexOf(item);
      if (index !== 0 && postBody[index - 1]?.listItem !== 'bullet') {
        ulFirstId.push(UlList.indexOf(item));
      }
    }
    if (item.listItem === 'number') {
      OlList.push(item);
      const index = postBody.indexOf(item);
      if (index !== 0 && postBody[index - 1]?.listItem !== 'number') {
        olFirstId.push(OlList.indexOf(item));
      }
    }
  });

  ulFirstId.forEach((item) => {
    if (ulFirstId.indexOf(item) === ulFirstId.length - 1) {
      splitUlList.push(
        UlList.slice(UlList.indexOf(UlList[item]), UlList.length),
      );
    } else {
      const nextItem = ulFirstId[ulFirstId.indexOf(item) + 1];
      splitUlList.push(
        UlList.slice(
          UlList.indexOf(UlList[item]),
          UlList.indexOf(UlList[nextItem]),
        ),
      );
    }
  });
  olFirstId.forEach((item) => {
    if (olFirstId.indexOf(item) === olFirstId.length - 1) {
      splitOlList.push(
        OlList.slice(OlList.indexOf(OlList[item]), OlList.length),
      );
    } else {
      const nextItem = olFirstId[olFirstId.indexOf(item) + 1];
      splitOlList.push(
        OlList.slice(
          OlList.indexOf(OlList[item]),
          OlList.indexOf(OlList[nextItem]),
        ),
      );
    }
  });

  const postBlocks = postBody.map((Item) => {
    switch (Item._type) {
      case 'standout':
        return (
          <StandoutComponent
            title={Item.title}
            key={Item._key}
            text={Item.text}
            image={Item.image}
            ctaText={Item.ctaText}
            ctaUrl={Item.ctaUrl}
            illustration={Item.illustration}
          />
        );
      case 'blogPostImage':
        return (
          <PostBodyImage
            key={Item._key}
            image={Item.image}
            link={Item.link}
            caption={Item.caption}
            alt={Item.alt}
            isDecorativeImage
          />
        );
      case 'youtube':
        return <PostBodyVideo url={Item.url} caption={Item.caption} />;
      case 'blogHTMLField':
        return <CodeSnippet htmlCode={Item.htmlCode} />;
      case 'block':
        return (
          <PostBody
            block={Item}
            id={Item._key}
            key={Item._key}
            style={Item.style}
            marks={Item.children[0].marks}
            list={Item.listItem}
            tocData={blogPost.tocData}
            UlList={(ulFirstId[0] === -1 && UlList) || splitUlList}
            OlList={(olFirstId[0] === -1 && OlList) || splitOlList}
          />
        );
      default:
        throw new Error(`Block ${Item._type} not supported`);
    }
  });

  return <>{postBlocks}</>;
};
